import { Pipe, PipeTransform } from '@angular/core';

import lodash from 'lodash';

/*
  Pipe that returns the value of a key in the object.
*/
@Pipe({
  name: 'key',
})
export class KeyPipe implements PipeTransform {
  transform(value: Record<string | number, any>, key: string | number): any {
    return lodash.get(value, key);
  }
}
